import { render, staticRenderFns } from "./OptStatistics.vue?vue&type=template&id=1603e70e&scoped=true"
import script from "./OptStatistics.vue?vue&type=script&lang=js"
export * from "./OptStatistics.vue?vue&type=script&lang=js"
import style0 from "./OptStatistics.vue?vue&type=style&index=0&id=1603e70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1603e70e",
  null
  
)

export default component.exports